import { combineEpics } from 'redux-observable'
import { concatAll, switchMap } from 'rxjs/operators'

import { Epic } from 'modules/store'

import { Providers } from '../../../app/core/core.module'
import { BadgeType } from '../../../app/shared'
import * as fromActions from './signal-r.actions'

export const initGoalBadge: Epic<any, any, Providers> = (actions$, _, { signalRService }) => {
  return actions$.ofType<fromActions.GoalBadgeInitAction>(fromActions.SIGNALR_GOAL_BADGE_INIT).pipe(
    switchMap((action) => {
      return signalRService
        .initBadges(action.payload, BadgeType.goal)
        .then((response) => {
          return [new fromActions.GoalBadgeInitSuccessAction(response)]
        })
        .catch((reason) => {
          return [new fromActions.GoalBadgeInitFailureAction(reason)]
        })
    }),
    concatAll()
  )
}

export const initFeedbackBadge: Epic<any, any, Providers> = (actions$, _, { signalRService }) => {
  return actions$.ofType<fromActions.FeedbackBadgeInitAction>(fromActions.SIGNALR_FEEDBACK_BADGE_INIT).pipe(
    switchMap((action) => {
      return signalRService
        .initBadges(action.payload, BadgeType.feedback)
        .then((response) => {
          return [new fromActions.FeedbackBadgeInitSuccessAction(response)]
        })
        .catch((reason) => {
          return [new fromActions.FeedbackBadgeInitFailureAction(reason)]
        })
    }),
    concatAll()
  )
}

export const initMyTeamBadge: Epic<any, any, Providers> = (actions$, _, { signalRService }) => {
  return actions$.ofType<fromActions.MyTeamBadgeInitAction>(fromActions.SIGNALR_MY_TEAM_BADGE_INIT).pipe(
    switchMap((action) => {
      return signalRService
        .initBadges(action.payload, BadgeType.myTeam)
        .then((response) => {
          return [new fromActions.MyTeamBadgeInitSuccessAction(response)]
        })
        .catch((reason) => {
          return [new fromActions.MyTeamBadgeInitFailureAction(reason)]
        })
    }),
    concatAll()
  )
}

export const initReviewBadge: Epic<any, any, Providers> = (actions$, _, { signalRService }) => {
  return actions$.ofType<fromActions.ReviewBadgeInitAction>(fromActions.SIGNALR_REVIEW_BADGE_INIT).pipe(
    switchMap((action) => {
      return signalRService
        .initBadges(action.payload, BadgeType.review)
        .then((response) => {
          return [new fromActions.ReviewBadgeInitSuccessAction(response)]
        })
        .catch((reason) => {
          return [new fromActions.ReviewBadgeInitFailureAction(reason)]
        })
    }),
    concatAll()
  )
}

export const initTeamGoalBadge: Epic<any, any, Providers> = (actions$, _, { signalRService }) => {
  return actions$.ofType<fromActions.TeamGoalBadgeInitAction>(fromActions.SIGNALR_TEAM_GOAL_BADGE_INIT).pipe(
    switchMap((action) => {
      return signalRService
        .initBadges(action.payload, BadgeType.teamGoals)
        .then((response) => {
          return [new fromActions.TeamGoalBadgeInitSuccessAction(response)]
        })
        .catch((reason) => {
          return [new fromActions.TeamGoalBadgeInitFailureAction(reason)]
        })
    }),
    concatAll()
  )
}

export const initTeamReviewBadge: Epic<any, any, Providers> = (actions$, _, { signalRService }) => {
  return actions$.ofType<fromActions.TeamReviewBadgeInitAction>(fromActions.SIGNALR_TEAM_REVIEW_BADGE_INIT).pipe(
    switchMap((action) => {
      return signalRService
        .initBadges(action.payload, BadgeType.teamReview)
        .then((response) => {
          return [new fromActions.TeamReviewBadgeInitSuccessAction(response)]
        })
        .catch((reason) => {
          return [new fromActions.TeamReviewBadgeInitFailureAction(reason)]
        })
    }),
    concatAll()
  )
}

export const initAllBadges: Epic<any, any, Providers> = (actions$, _, { signalRService }) => {
  return actions$.ofType<fromActions.AllBadgeInitAction>(fromActions.SIGNALR_ALL_BADGES_INIT).pipe(
    switchMap((action) => {
      return signalRService
        .allBadges(action.payload)
        .then((response) => {
          return [new fromActions.AllBadgeInitSuccessAction(response)]
        })
        .catch((reason) => {
          return [new fromActions.AllBadgeInitFailureAction(reason)]
        })
    }),
    concatAll()
  )
}

export default combineEpics(
  initAllBadges,
  initGoalBadge,
  initFeedbackBadge,
  initMyTeamBadge,
  initReviewBadge,
  initTeamGoalBadge,
  initTeamReviewBadge
)



// WEBPACK FOOTER //
// ./src/modules/signal-r/store/signal-r.epic.ts